var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"long-text"},[_c('textarea',{staticClass:"tw-w-full tw-border-0 tw-border-b tw-bg-transparent focus:tw-outline-none focus:tw-ring-0",style:(_vm.style),attrs:{"required":_vm.config.required,"readonly":_vm.readonly,"rows":"4"},domProps:{"value":_vm.value},on:{"keyup":_vm.onAnswerInput,"paste":_vm.onAnswerInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }